'use client'

import { GetImFeelingLuckyProjectDocument } from '@/gql/generated/graphql'
import { BodyText } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { LoadingSpinner } from '@components/loading-spinner'
import { AllPurposeLink } from '@components/all-purpose-link'
import { projectShowRoute } from '@utils/routes'
import { useQuery } from 'urql'

const randomStart = `${Math.random()}`

export const SupriseMe = (): React.ReactElement => {
  const [imageLoaded, setImageLoaded] = React.useState(false)

  const [randomNum, setRandomNum] = React.useState<string>(randomStart)

  const [res] = useQuery({
    query: GetImFeelingLuckyProjectDocument,
    variables: {
      projectsMetadataAggFilter: {
        tokens: { image_id: { _is_null: false } }
      },
      seed: randomNum
    }
  })

  const project = res.data?.list_projects_metadata_random?.[0] ?? null

  React.useEffect(() => {
    if (res.fetching) {
      setImageLoaded(false)
    }
  }, [res.fetching])

  return (
    <div className="gap-y-xs flex w-full flex-col items-center">
      <AnimatePresence>
        {!res.fetching && project ? (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
              className="gap-y-xs flex w-full flex-col items-center"
            >
              <div className="my-md relative h-[300px] w-full">
                {!imageLoaded ? (
                  <div className="absolute right-[30%] top-[50%]">
                    <LoadingSpinner className="h-md w-md" light />
                  </div>
                ) : null}
                <AllPurposeLink href={projectShowRoute(project.slug)}>
                  <ImageWithCustomLoader
                    onLoad={() => setImageLoaded(true)}
                    src={project.featured_token?.[0]?.media_url || ''}
                    alt={`${project.name} featured token`}
                    fill
                    sizes="20vw"
                    style={{ objectFit: 'contain', objectPosition: 'center' }}
                    className="drop-shadow-[2px_2px_15px_rgba(0,0,0,0.16)]"
                  />
                </AllPurposeLink>
              </div>
              <BodyText className="text-on-surface text-center">
                <BodyText className="text-on-surface font-medium">
                  {project.name} #{project.featured_token?.[0].invocation}
                </BodyText>
                {project.artist_name}
              </BodyText>
            </motion.div>
          </>
        ) : (
          <>
            <div className="my-md relative h-[300px] w-full opacity-0" />
            <BodyText className="text-on-surface text-center opacity-0">
              <BodyText className="text-on-surface font-medium opacity-0">A</BodyText>
              by A
            </BodyText>
          </>
        )}
      </AnimatePresence>
      <button
        className="mt-md rounded-xs bg-primary hover:bg-primary-inverted-80 text-on-primary px-sm py-xs"
        onClick={() => setRandomNum(`${Math.random()}`)}
      >
        <BodyText>Surprise me</BodyText>
      </button>
    </div>
  )
}
